import { Component, OnInit, Input } from '@angular/core';
import { camps } from '../../../models/models.generated';


@Component({
    selector: 'app-roster-item',
    templateUrl: './roster-item.component.html',
    styleUrls: ['./roster-item.component.scss'],
    standalone: false
})
export class RosterItemComponent implements OnInit {

    @Input()
    public item: camps.RosterInfoItem;

    constructor() { }

    ngOnInit() {
    }

}
